import React from "react";
import { Icon } from "../../../../components/Component";

const PrimaryUserGateNotice = () => (
  <div className="alert alert-warning mb-4" role="alert">
    <Icon name="alert-circle" className="me-1" />
    <strong>Step 1:</strong> This partner has no primary login account linked. Open the <strong>Team</strong> tab, search an
    existing user, and use <strong>Link primary account</strong> (admin only), or create the user under Users first — then edit
    their profile if needed before linking.
  </div>
);

export default PrimaryUserGateNotice;
